'use client';

export { default } from '@mui/material/usePagination';